import * as THREE from "three";

export const galleryItems = [
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(20, 0.3, -15),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "/venna_art/Illustration3_mobileWallpaper.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "mimuchi.glb",
    position: new THREE.Vector3(18, 0.3, -14),
    rotation: new THREE.Euler((-0.1 / 2) * Math.PI, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "screen",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },

  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(28, -0.3, -15),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "/venna_art/Illustration15.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(36, -0.3, -15),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "/venna_art/Illustration48.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(44, -0.3, -15),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration139.clipbu.pngbu.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(52, -0.3, -15),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration173.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(52, -0.3, -25),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration157a.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(44, -0.3, -25),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration184.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(36, -0.3, -25),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration35.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(28, -0.3, -25),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration32.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(20, -0.3, -25),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "venna_art/Illustration7BU.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(52, -0.3, -35),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "/venna_art/Illustration22.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "board_A4_portrait.glb",
    position: new THREE.Vector3(44, -0.3, -35),
    rotation: new THREE.Euler(0, (4 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "screen",
    screenshotPath: "/venna_art/Illustration49.webp",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null,
  },
  // {
  //     modelPath: 'foundation_acrylic_stand.glb',
  //     position: new THREE.Vector3(16, -0.3, -7),
  //     rotation: new THREE.Euler(0, 0, 0),
  //     scale: new THREE.Vector3(1, 1, 1),
  //     type: 'screen',
  //     screenshotPath: '/venna_art/Illustration139.clipbu.pngbu.png',
  //     enableCollision: true,
  //     enablePhysics: true,
  //     mass: 4,
  //     friction: 0.000001,
  //     physicsShape: 'box',
  //     interactionCallback: null
  // },
];
